export enum EnvironmentalFootprintDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP'
}
